<template>
    <div class="ppv2-space-y-2">
        <!-- Label -->
        <BaseLabel :label="label" :required="required" />

        <InfoMessageBox v-if="tooltipMsg" class="ppv2-mt-2" :message="tooltipMsg" color="info" />

        <!-- Description -->
        <p v-if="description" class="ppv2-text-xs ppv2-text-gray-500">{{ description }}</p>

        <!-- Map container -->
        <div id="map" ref="mapContainer" class="ppv2-rounded-lg ppv2-overflow-hidden ppv2-mt-2 ppv2-map"></div>
    </div>
</template>

<script>
import BaseLabel from './BaseLabel.vue'
import InfoMessageBox from './InfoMessageBox.vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
    name: 'InteractiveMap',
    components: {
        BaseLabel,
        InfoMessageBox,
    },
    props: {
        label: String,
        description: String,
        required: Boolean,
        tooltipMsg: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            map: null,
            marker: null,
            coordinates: {
                lat: 48.8566,
                lng: 2.3522,
            },
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initMap()
        })
    },
    methods: {
        initMap() {
            const container = this.$refs.mapContainer
            if (!container) return

            this.map = L.map(container).setView([this.coordinates.lat, this.coordinates.lng], 13)

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '', // Required for legal use
                maxZoom: 19,
            }).addTo(this.map)

            const customRedMarker = L.divIcon({
                className: '',
                html: `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 48" width="32" height="48">
            <path d="M16 0C7.2 0 0 7.2 0 16c0 11.3 16 32 16 32s16-20.7 16-32C32 7.2 24.8 0 16 0z" fill="#EF4444"/>
            <circle cx="16" cy="16" r="6" fill="white"/>
          </svg>
        `,
                iconSize: [32, 48],
                iconAnchor: [16, 48],
            })

            this.marker = L.marker([this.coordinates.lat, this.coordinates.lng], {
                draggable: true,
                icon: customRedMarker,
            }).addTo(this.map)

            this.map.on('click', this.onMapClick)

            this.marker.on('moveend', (e) => {
                const { lat, lng } = e.target.getLatLng()
                this.updateCoordinates(lat, lng)
            })
        },
        onMapClick(e) {
            const { lat, lng } = e.latlng
            this.marker.setLatLng(e.latlng)
            this.updateCoordinates(lat, lng)
        },
        updateCoordinates(lat, lng) {
            this.coordinates = { lat, lng }
            this.$emit('coordinates-updated', this.coordinates)
        },
        updateMapCenter(lat, lng) {
            console.log('Updating map center to:', lat, lng)
            if (this.map) {
                this.map.setView([lat, lng], this.zoomLevel)
                this.marker.setLatLng([lat, lng])
            }
        },
    },
}
</script>

<style scoped>
.ppv2-map {
    height: 300px;
    margin-top: 1rem !important;
}
/* Optional: make attribution smaller or repositioned */
:deep(.leaflet-control-attribution) {
    font-size: 11px;
    bottom: 4px !important;
    right: 8px !important;
}

/* Optionally make it less obtrusive but still visible (legal) */
:deep(.leaflet-control-attribution) a {
    color: #999 !important;
    text-decoration: none;
}
</style>
